import React, { useState } from 'react';
import { toLatinDigits } from '../../utils/nationalCode';

/** مرحله‌ی دوم ورود: کد ۶ رقمی برنامه یا یکی از کدهای پشتیبان */
export default function TwoFactorCodeStep({ onSubmit, onBack, error, loading }) {
  const [code, setCode] = useState('');
  const [useBackup, setUseBackup] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    const value = toLatinDigits(code).trim();
    onSubmit(useBackup ? value : value.replace(/\D/g, ''));
  };

  const ready = useBackup ? code.trim().length >= 8 : toLatinDigits(code).replace(/\D/g, '').length >= 6;

  return (
    <form onSubmit={submit} className="space-y-4">
      <div className="text-center">
        <div className="mx-auto mb-3 grid h-14 w-14 place-items-center rounded-2xl bg-emerald-500/20 text-2xl">🔐</div>
        <h2 className="text-xl font-black text-white">تأیید دو مرحله‌ای</h2>
        <p className="mt-1 text-sm leading-7 text-white/50">
          {useBackup
            ? 'یکی از کدهای پشتیبان خود را وارد کنید (هر کد فقط یک بار)'
            : 'کد ۶ رقمی برنامه‌ی احراز هویت را وارد کنید'}
        </p>
      </div>

      <input
        key={useBackup ? 'backup' : 'totp'}
        autoFocus
        dir="ltr"
        inputMode={useBackup ? 'text' : 'numeric'}
        autoComplete="one-time-code"
        maxLength={useBackup ? 14 : 7}
        value={code}
        onChange={(e) => setCode(e.target.value)}
        placeholder={useBackup ? 'XXXXX-XXXXX' : '------'}
        className="h-14 w-full rounded-2xl border-2 border-white/10 bg-white/5 text-center font-mono text-2xl tracking-[0.4em] text-white outline-none transition placeholder:text-white/20 focus:border-emerald-400"
      />

      {error && (
        <div className="rounded-xl border border-red-400/20 bg-red-500/10 p-3 text-sm text-red-300">{error}</div>
      )}

      <button
        type="submit"
        disabled={loading || !ready}
        className="h-12 w-full rounded-full bg-floodlight font-black text-ink shadow-lime transition hover:-translate-y-0.5 disabled:opacity-50 disabled:hover:translate-y-0"
      >
        {loading ? 'در حال بررسی...' : 'ورود'}
      </button>

      <div className="flex items-center justify-between text-xs font-bold">
        <button
          type="button"
          onClick={() => {
            setUseBackup((v) => !v);
            setCode('');
          }}
          className="text-floodlight hover:underline"
        >
          {useBackup ? 'استفاده از کد برنامه' : 'استفاده از کد پشتیبان'}
        </button>
        <button type="button" onClick={onBack} className="text-white/50 hover:text-white">
          بازگشت
        </button>
      </div>
    </form>
  );
}
